import React, { useRef, useEffect, useContext } from "react";
import { Col, Container, Row } from "react-bootstrap";
import { generateStars } from "./styles";
import styles from "./index.module.css";
import lottieJson from "../../../assets/lottie/hero.json";
import G1 from "../../../assets/trt/1.png";
import G2 from "../../../assets/trt/2.png";
import G3 from "../../../assets/trt/3.png";
import G4 from "../../../assets/trt/4.png";
import Lottie from "react-lottie-player";
import { AppContext } from "../../../scripts/context";
/*  This Component view when disconnect to wallet | khaled Mofeed */
function Index({ openConnectModal, account, connected }) {
  const { state: { connectWallet } = {}, disconnect } =
    useContext(AppContext) || {};

  useEffect(() => {
    if (!account) {
      disconnect();
    }
  }, [account, connected]);

  // Removed unused props and disconnect logic to prevent infinite loop

  // useEffect(() => {
  //   document.body.classList.add("ConnectToYourWallet");

  //   let classIndex = 0;
  //   const classNames = [
  //     "backgroundSlide1",
  //     "backgroundSlide2",
  //     "backgroundSlide3",
  //     "backgroundSlide4",
  //     "backgroundSlide5",
  //   ];

  //   const updateClassName = () => {
  //     const currentClassName = classNames[classIndex];
  //     document.body.classList.remove(
  //       "backgroundSlide1",
  //       "backgroundSlide2",
  //       "backgroundSlide3",
  //       "backgroundSlide4",
  //       "backgroundSlide5"
  //     );
  //     document.body.classList.add(currentClassName);
  //     classIndex = (classIndex + 1) % classNames.length;
  //   };

  //   const intervalId = setInterval(updateClassName, 5000);

  //   return () => {
  //     document.body.classList.remove("ConnectToYourWallet");
  //     document.body.classList.remove(
  //       "backgroundSlide1",
  //       "backgroundSlide2",
  //       "backgroundSlide3",
  //       "backgroundSlide4",
  //       "backgroundSlide5"
  //     );
  //     clearInterval(intervalId);
  //   };
  // }, []);

  const starContainerRef = useRef(null);

  useEffect(() => {
    if (starContainerRef.current) {
      const removeStars = generateStars(
        starContainerRef.current,
        120,
        100,
        true
      );
      return () => {
        removeStars?.();
      };
    }
  }, []);
  // Empty dependency array ensures this effect runs only once (on mount)
  return (
    <Container
      fluid
      className={`px-0 mx-0 ${styles.heroContainer} ${styles.blur} ${styles.withoutConstantAnimation}`}
      style={{ marginTop: "-100px", overflow: "hidden" }}
    >
      {/* <Row> */}
      {/* <div className="mil-overlay"></div> */}
      {/* <Col md={{ offset: 1, span: 10 }} className="text-center"> */}
      <Row
        ref={starContainerRef}
        className={`text-center justify-content-center mb-mobile-4rem  ${styles.card}`}
      >
        <Col xs={12} sm={11} md={10} lg={8} xl={6} className="px-3 px-md-0">
          <div className="under-hero">
            <h1 className="bold mb-3">
              Welcome To
              <br />
              <span className="text-gradient">The Ownership Economy</span>
            </h1>
            <p className="text-white w-140 mob-w-75 hero-tagline">
              “Don't just use AI – Own it” 100% transparent - Easy to verify
              on-chain
            </p>
          </div>
          <Lottie
            className={`lottiePlayer`}
            loop
            animationData={lottieJson}
            play
          />

          <img src={G1} alt="group1" className={styles.group1} />
          <img src={G2} alt="group2" className={styles.group2} />
          <img src={G3} alt="group3" className={styles.group3} />
          <img src={G4} alt="group4" className={styles.group4} />
        </Col>
      </Row>
      {/* </Col> */}
      {/* </Row> */}
    </Container>
  );
}

export default Index;
